import axios from "axios";
import { makeAutoObservable, toJS } from "mobx";
import Tool from "../pages/ROI/Tool";
import ToolStore from "./ToolStore";

class GoalsStore {
  defaultsValues = {};
  data = {};
  changed = {};
  reset() {
    this.defaultsValues = {};
    this.data = {};
    this.changed = {};
  }
  constructor() {
    makeAutoObservable(this);
  }

  setDefaultsValues() {
    this.defaultsValues = this.toFormatJson();
  }
  getData() {
    return toJS(this.data);
  }

  setData(values) {
    this.data = values;
  }
  setChanged(values) {
    this.changed = values;
  }

  setChangedFirst(values) {
    this.changed = values;
  }
  toFormatChanged() {
    var json = {
      targetAnnualGrowth: false,
    };

    return json;
  }
  toFormatJson() {
    var json = {
      targetAnnualGrowth: 0,
    };
    try {
      json = {
        targetAnnualGrowth: toJS(this.data)[0].value[0].value,
      };
    } catch (error) {}

    return json;
  }
  toUpdateConversion(newValues) {
    const selected = toJS(this.data)[0];
    if (selected.value[0].value != newValues["targetAnnualGrowth"]) {
      selected.value[0].changed = true;
    }
    selected.value[0].value = newValues["targetAnnualGrowth"];

    this.data[0] = selected;
    this.toUpdateParent();
  }

  toUpdateParent() {
    ToolStore.toUpdate("goalsAndObjectives", this.getData());
  }
}

export default new GoalsStore();
